import React, { useEffect, useState } from 'react';
import { useTrackingContext } from '../../../context/trackingContext';
import { useUserContext } from '../../../context/userContext';
import Alert from '../../../components/Alert';

const ReferFriend = () => {
  const { trackPageView } = useTrackingContext();
  const { referrals, userData } = useUserContext();
  const [copyAlert, setCopyAlert] = useState(null);

  useEffect(() => {
    trackPageView({
      pageName: 'Refer a friend page'
    });
  }, []);

  const copyCode = () => {
    navigator.clipboard.writeText(window.location.origin + '/r/' + userData.referralId);
    setCopyAlert({ text: 'Link copied!', success: true });
  };

  return (
    <div id="referFriend">
      <div className="mb-10">
        <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-5" />
        <div className="flex flex-col justify-between mb-5">
          <p className="mb-2">Referrals Received: {userData.referralLimit}</p>
          <p className="mb-2">Referrals Used: {referrals.length}</p>
          <p className="mb-2">Referrals Remaining: {userData.referralLimit - referrals.length}</p>
        </div>
        <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-5" />
        <div className="flex flex-col justify-between mb-5">
          <h2 className="font-Korolev-Bold text-xl mb-2">Instructions</h2>
          <ol className="p-5 list-decimal">
            <li>Copy the link below</li>
            <li>Send the referral link to your friends</li>
            <li>Once your friend creates an account, you will see their username show up here</li>
          </ol>
        </div>
        <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-5" />
        <div className="flex flex-col justify-between mb-5">
          <h2 className="font-Korolev-Bold text-xl mb-2">Referral Link</h2>
          <p className="mb-2">
            {window.location.origin + '/r/'}
            {userData.referralId}
          </p>
          <button
            className="uppercase w-full sm:w-[250px] pt-4 pb-3 bg-black text-white"
            onClick={() => copyCode()}>
            Copy Referral Link
          </button>
          {copyAlert && (
            <div className="mt-5">
              <Alert setShowAlert={setCopyAlert} loggedIn success={copyAlert.success}>
                <p className="pr-12 text-sm md:text-base">{copyAlert.text}</p>
              </Alert>
            </div>
          )}
        </div>
        {referrals.length > 0 && (
          <>
            <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-5" />
            <div className="flex flex-col justify-between mb-5">
              <h2 className="font-Korolev-Bold text-xl mb-2">Referred Friends</h2>
              <div className="overflow-x-auto">
                <table className="table-auto w-full min-w-[600px]">
                  <thead>
                    <tr className="text-left">
                      <th className="pb-3">Username</th>
                      <th className="pb-3">Date and Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referrals.map((login, idx) => (
                      <tr key={idx}>
                        <td className="pb-3">{login.username}</td>
                        <td className="pb-3">{login.createdAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReferFriend;
